jQuery(document).ready(function($){

    function quantityDiscountInit() {
        const default_dis_q         = $('input[name="default_dis_q"]').val();
        var form                    = $('.single-product__row form.variations_form');
        var $singleVariationWrap    = form.find( '.single_variation_wrap' );
        var $qty                    = $singleVariationWrap.find( '.quantity' );
        var dis_q                   = default_dis_q ? default_dis_q : 0;
        var dis_p                   = 10;
        var simple_p_price          = $('input[name="default_price"]').val();
        var simple_p_regular_price  = $('input[name="default_regular_price"]').val();
        var qty_data                = {};
        var product_price           = {};
        var regular_price           = {};
        var q_val                   = 1;
        var var_on_sale             = false;

        function round(num, precision) {
            return (+(Math.round(+(num + 'e' + precision)) + 'e' + -precision)).toFixed(precision);
        }

        $qty.each( function(key, value){
            qty_data[key] = $(value).find( 'input.qty' ).val();
        });


        let simpleProductCartForm = $('.product-type-simple').find('form.cart');

        $('.product-type-simple').find('form.cart').each(function( key, value){
            q_val = $(value).find('input.qty').val();

            var $priceContainer = $(value).find('.price');

            $(value).find('input.qty').attr( 'min', q_val );

            if($priceContainer.find('ins').length > 0){
                $priceContainer.find('ins').find('.woocommerce-Price-amount').contents().filter(function() {

                    return this.nodeType === 3;
                }).replaceWith(function() {
                    return this.nodeValue.replace(this.nodeValue, calc_price( simple_p_price, q_val, dis_q, dis_p, false));
                });
                $priceContainer.find('del').find('.woocommerce-Price-amount').contents().filter(function() {

                    return this.nodeType === 3;
                }).replaceWith(function() {

                    return this.nodeValue.replace(this.nodeValue, calc_regular_price( simple_p_regular_price, q_val));
                });

                $priceContainer.find('ins').find('.woocommerce-Price-amount bdi').contents().filter(function() {

                    return this.nodeType === 3;
                }).replaceWith(function() {
                    return this.nodeValue.replace(this.nodeValue, calc_price( simple_p_price, q_val, dis_q, dis_p, false));
                });
                $priceContainer.find('del').find('.woocommerce-Price-amount bdi').contents().filter(function() {

                    return this.nodeType === 3;
                }).replaceWith(function() {

                    return this.nodeValue.replace(this.nodeValue, calc_regular_price( simple_p_regular_price, q_val));
                });

            }else{
                $priceContainer.find('.woocommerce-Price-amount').contents().filter(function() {
                    return this.nodeType === 3;
                }).replaceWith(function() {
                    return this.nodeValue.replace(this.nodeValue, calc_price( simple_p_price, q_val, dis_q, dis_p));
                });

                $priceContainer.find('.woocommerce-Price-amount bdi').contents().filter(function() {
                    return this.nodeType === 3;
                }).replaceWith(function() {
                    return this.nodeValue.replace(this.nodeValue, calc_price( simple_p_price, q_val, dis_q, dis_p));
                });

            }
        });

        $('input.qty').on('change', function(){
            const maxStockAttr = $(this).attr('max');

            let maxStock = maxStockAttr ? parseInt( maxStockAttr ) : 0;

            if($(this).closest('li.product').length > 0){
                var price = 0;
                var reg_price = 0;
                var thisQ = $(this).val();

                if (thisQ > maxStock) {
                    thisQ = maxStock;
                    $(this).val(thisQ);
                } else if (thisQ < 1 ) {
                    thisQ = 1;
                    $(this).val(thisQ);
                }

                if($(this).closest('li.product').hasClass('product-type-variable')){
                    var data = $.parseJSON($(this).closest('li.product').find('form').attr('data-product_variations'));
                    var var_obj = data.find(x => x.variation_id == $(this).closest('li.product').find('input[name="variation_id"]').val());
                    price = var_obj.display_price;
                    reg_price = var_obj.display_regular_price;
                }else{
                    var d_price = $(this).closest('li.product').find('input[name="default_price"]').val();
                    var d_reg_price = $(this).closest('li.product').find('input[name="default_regular_price"]').val();

                    price = round(d_price * 1.21, 2);
                    reg_price = round(d_reg_price * 1.21, 2);
                }

                var $priceContainer = $(this).closest('li.product').find('.price');
                let $disq = $(this).closest('li.product').find('input[name="default_dis_q"]');
                let $disp = 10;

                if($disq.length > 0){
                    var thisQ = $(this).val();

                    var $priceContainer = $(this).closest('li.product').find('.price');
                    if($priceContainer.find('ins').length > 0){
                        $priceContainer.find('ins').find('.woocommerce-Price-amount').contents().filter(function() {

                            return this.nodeType === 3;
                        }).replaceWith(function() {
                            return this.nodeValue.replace(this.nodeValue, calc_price( price, thisQ, $disq.val(), 10, false));
                        });
                        $priceContainer.find('del').find('.woocommerce-Price-amount').contents().filter(function() {

                            return this.nodeType === 3;
                        }).replaceWith(function() {

                            return this.nodeValue.replace(this.nodeValue, calc_regular_price( reg_price, thisQ));
                        });
                        $priceContainer.find('ins').find('.woocommerce-Price-amount bdi').contents().filter(function() {

                            return this.nodeType === 3;
                        }).replaceWith(function() {
                            return this.nodeValue.replace(this.nodeValue, calc_price( price, thisQ, $disq.val(), 10, false));
                        });
                        $priceContainer.find('del').find('.woocommerce-Price-amount bdi').contents().filter(function() {

                            return this.nodeType === 3;
                        }).replaceWith(function() {

                            return this.nodeValue.replace(this.nodeValue, calc_regular_price( reg_price, thisQ));
                        });
                    }else{
                        $priceContainer.find('.woocommerce-Price-amount').contents().filter(function() {
                            return this.nodeType === 3;
                        }).replaceWith(function() {

                            return this.nodeValue.replace(this.nodeValue, calc_price( price, thisQ, $disq.val(), 10));
                        });
                        $priceContainer.find('.woocommerce-Price-amount bdi').contents().filter(function() {
                            return this.nodeType === 3;
                        }).replaceWith(function() {

                            return this.nodeValue.replace(this.nodeValue, calc_price( price, thisQ, $disq.val(), 10));
                        });

                    }
                }else{
                    if ($priceContainer.find('ins').length > 0){
                        $priceContainer.find('ins').find('.woocommerce-Price-amount').contents().filter(function() {

                            return this.nodeType === 3;
                        }).replaceWith(function() {
                            return this.nodeValue.replace(this.nodeValue, calc_price( price, thisQ, $disq.val(), 10, false));
                        });
                        $priceContainer.find('del').find('.woocommerce-Price-amount').contents().filter(function() {

                            return this.nodeType === 3;
                        }).replaceWith(function() {

                            return this.nodeValue.replace(this.nodeValue, calc_regular_price( reg_price, thisQ));
                        });

                        $priceContainer.find('ins').find('.woocommerce-Price-amount bdi').contents().filter(function() {

                            return this.nodeType === 3;
                        }).replaceWith(function() {
                            return this.nodeValue.replace(this.nodeValue, calc_price( price, thisQ, $disq.val(), 10, false));
                        });
                        $priceContainer.find('del').find('.woocommerce-Price-amount bdi').contents().filter(function() {

                            return this.nodeType === 3;
                        }).replaceWith(function() {

                            return this.nodeValue.replace(this.nodeValue, calc_regular_price( reg_price, thisQ));
                        });
                    }else{
                        $priceContainer.find('.woocommerce-Price-amount').contents().filter(function() {
                            return this.nodeType === 3;
                        }).replaceWith(function() {
                            return this.nodeValue.replace(this.nodeValue, calc_price( price, thisQ, $disq.val(), 10));
                        });

                        $priceContainer.find('.woocommerce-Price-amount bdi').contents().filter(function() {
                            return this.nodeType === 3;
                        }).replaceWith(function() {
                            return this.nodeValue.replace(this.nodeValue, calc_price( price, thisQ, $disq.val(), 10));

                        });
                    }

                }
            } else {
                $qty.each( function(key, value){
                    q_val = $(value).find('input.qty').val();
                    var price = 0;
                    var reg_price = 0;
                    var thisQ = q_val;

                    if (thisQ > maxStock) {
                        thisQ = maxStock;

                        $(value).find('input.qty').val(thisQ);
                    } else if (thisQ < 1 ) {
                        thisQ = 1;
                        $(this).val(thisQ);
                    }

                    if($(value).closest('.product').hasClass('product-type-variable')){
                        var data = $.parseJSON($(value).closest('.product').find('form').attr('data-product_variations'));
                        var var_obj = data.find(x => x.variation_id == $(value).closest('.product').find('input[name="variation_id"]').val());

                        price = var_obj.display_price;
                        reg_price = var_obj.display_regular_price;
                    }else{
                        price = $(this).closest('.product').find('input[name="default_price"]').val();
                        reg_price = $(this).closest('.product').find('input[name="default_regular_price"]').val();
                    }

                    var $priceContainer = $(value).parent('.woocommerce-variation-add-to-cart').find('.price');
                    const default_dis_q = $('input[name="default_dis_q"]').val();
                    var dis_q1 = default_dis_q ? default_dis_q : 0;

                    if(var_on_sale){
                        $('.single_variation_wrap.qdiscount-wrapper').addClass('hide');
                    }else{
                        $('.single_variation_wrap.qdiscount-wrapper').removeClass('hide');
                    }

                    q_val = thisQ;

                    if($priceContainer.find('ins').length > 0){
                        $priceContainer.find('ins').find('.woocommerce-Price-amount').contents().filter(function() {

                            return this.nodeType === 3;
                        }).replaceWith(function() {
                            return this.nodeValue.replace(this.nodeValue, calc_price( price, q_val, dis_q, dis_p, false));
                        });
                        $priceContainer.find('del').find('.woocommerce-Price-amount').contents().filter(function() {

                            return this.nodeType === 3;
                        }).replaceWith(function() {
                            return this.nodeValue.replace(this.nodeValue, calc_regular_price( reg_price, q_val));
                        });


                        $priceContainer.find('ins').find('.woocommerce-Price-amount bdi').contents().filter(function() {

                            return this.nodeType === 3;
                        }).replaceWith(function() {
                            return this.nodeValue.replace(this.nodeValue, calc_price( price, q_val, dis_q, dis_p, false));
                        });
                        $priceContainer.find('del').find('.woocommerce-Price-amount bdi').contents().filter(function() {

                            return this.nodeType === 3;
                        }).replaceWith(function() {
                            return this.nodeValue.replace(this.nodeValue, calc_regular_price( reg_price, q_val));
                        });
                    }else{
                        $priceContainer.find('.woocommerce-Price-amount').contents().filter(function() {
                            return this.nodeType === 3;
                        }).replaceWith(function() {
                            return this.nodeValue.replace(this.nodeValue, calc_price( price, q_val, dis_q, (var_on_sale) ? 0 : dis_p, (dis_q == 0) ? false : true));
                        });

                        $priceContainer.find('.woocommerce-Price-amount bdi').contents().filter(function() {
                            return this.nodeType === 3;
                        }).replaceWith(function() {
                            return this.nodeValue.replace(this.nodeValue, calc_price( price, q_val, dis_q, (var_on_sale) ? 0 : dis_p, (dis_q == 0) ? false : true));
                        });
                    }
                });

                $('.product-type-simple').find('form.cart').each(function( key, value){
                    let quantityInput = $(value).find('input.qty');
                    q_val = quantityInput.val();
                    const default_dis_q = $('input[name="default_dis_q"]').val();

                    dis_q = default_dis_q ? default_dis_q : 0;

                    if (q_val > maxStock) {
                        q_val = maxStock;
                        quantityInput.val(q_val);
                    } else if (q_val < 1 ) {
                        q_val = 1;
                        quantityInput.val(q_val);
                    }

                    var $priceContainer = $(value).find('.price');
                    if($priceContainer.find('ins').length > 0){
                        $priceContainer.find('ins').find('.woocommerce-Price-amount').contents().filter(function() {

                            return this.nodeType === 3;
                        }).replaceWith(function() {
                            return this.nodeValue.replace(this.nodeValue, calc_price( simple_p_price, q_val, dis_q, dis_p, false));
                        });
                        $priceContainer.find('del').find('.woocommerce-Price-amount').contents().filter(function() {

                            return this.nodeType === 3;
                        }).replaceWith(function() {

                            return this.nodeValue.replace(this.nodeValue, calc_regular_price( simple_p_regular_price, q_val));
                        });

                        $priceContainer.find('ins').find('.woocommerce-Price-amount bdi').contents().filter(function() {

                            return this.nodeType === 3;
                        }).replaceWith(function() {
                            return this.nodeValue.replace(this.nodeValue, calc_price( simple_p_price, q_val, dis_q, dis_p, false));
                        });
                        $priceContainer.find('del').find('.woocommerce-Price-amount bdi').contents().filter(function() {

                            return this.nodeType === 3;
                        }).replaceWith(function() {

                            return this.nodeValue.replace(this.nodeValue, calc_regular_price( simple_p_regular_price, q_val));
                        });
                    }else {
                        $priceContainer.find('.woocommerce-Price-amount').contents().filter(function () {
                            return this.nodeType === 3;
                        }).replaceWith(function () {
                            return this.nodeValue.replace(this.nodeValue, calc_price(simple_p_price, q_val, dis_q, dis_p, (dis_q == 0) ? false : true));
                        });

                        $priceContainer.find('.woocommerce-Price-amount bdi').contents().filter(function () {
                            return this.nodeType === 3;
                        }).replaceWith(function () {
                            return this.nodeValue.replace(this.nodeValue, calc_price(simple_p_price, q_val, dis_q, dis_p, (dis_q == 0) ? false : true));
                        });
                    }
                });
            }
        });

        $('.quantity-sale').on('mouseenter', function(){
            $(this).find('.tooltip').removeClass('hide');
        }).on('mouseleave', function(){
            $(this).find('.tooltip').addClass('hide');
        });


        $(document).on( 'found_variation', 'form.cart', function( e, v ){
            dis_q = v.qty_disc;
            product_price = v.display_price;
            regular_price = v.display_regular_price;

            if( product_price < regular_price ){
                var_on_sale = true;
            }else{
                var_on_sale = false;
            }
            //product_price[v.variation_id] = v.display_price;
            //regular_price[v.variation_id] = v.display_regular_price;
            let id           = $(e.target).find('.qty').attr('id');
            let form = $('#' + id).closest('form');
            var $singleVariationWrap = form.find( '.single_variation_wrap' );
            var $qty           = $singleVariationWrap.find( '.quantity' );
            var quantityFieldCount = $qty.length;
            let haveQuantityDiscount = v.have_quantity_discount;

            replace_tooltip_qty(form, dis_q, (product_price < regular_price) ? true : false);
            calcl_tooltip(form, product_price, quantityFieldCount, var_on_sale, haveQuantityDiscount);

            $qty.each( function(key, value){
                if (quantityFieldCount > 1) {
                    if (key === 0) {
                        $(value).find( 'input.qty' ).attr( 'min', dis_q ).attr( 'max', v.max_qty ).val( (parseInt(dis_q) ? parseInt(dis_q) : 1) ).change();
                    } else {
                        $(value).find( 'input.qty' ).attr( 'min', v.min_qty ).attr( 'max', v.max_qty ).val( (parseInt(qty_data[key]) ? parseInt(qty_data[key]) : 1) ).change();
                    }
                } else {
                    $(value).find( 'input.qty' ).attr( 'min', v.min_qty ).attr( 'max', v.max_qty ).val( (parseInt(qty_data[key]) ? parseInt(qty_data[key]) : 1) ).change();
                }
            });

            $qty.show();
        });

        function calcl_tooltip( form, price, quantityFieldCount, onSale = false, haveQuantityDiscount = false ){
            if ( form.find('input[name="default_dis_q"]').length > 0 ){
                const singleVariationWrap = form.find('.single_variation_wrap');
                const quantitySaleContainer = singleVariationWrap.find('.quantity-sale');

                if ( quantitySaleContainer.length > 0 ) {
                    const $tooltip = form.find('.quantity-sale .tooltip');

                    if ( onSale || !haveQuantityDiscount || ( onSale && !haveQuantityDiscount ) ) {
                        quantitySaleContainer.addClass('hide');
                    } else {
                        quantitySaleContainer.removeClass('hide');

                        var html = $tooltip.text();
                        var price_without_tax = (price / 1.21).toFixed(2);

                        // var single_dis_price = price - price * 10 / 100;
                        var single_dis_price_without_tax = ( price_without_tax - price_without_tax * 10 / 100 ).toFixed(2); ;
                        var single_dis_price_with_tax = single_dis_price_without_tax * 1.21;

                        var rounded_dic_price = single_dis_price_with_tax.toFixed(2);

                        html = html.replace(/(\d*\.)\d+/, rounded_dic_price.toString());
                        $tooltip.text(html);
                    }
                }
            }
        }

        function replace_tooltip_qty(form, qty, dis = false){
            const quantitySaleContainer = form.find('.single_variation_wrap').find('.quantity-sale');
            const $tooltip = form.find('.quantity-sale .tooltip');
            let html = $tooltip.text();

            if ( qty > 0 ){
                form.find('.qdiscount-wrapper').find('input.qty').attr('value', qty).change();
                let modHtml = html.replace(/\d+/, qty);
                $tooltip.text(modHtml);

                quantitySaleContainer.show();
            } else {
                if (quantitySaleContainer) {
                    quantitySaleContainer.hide();
                }
            }
        }

        function calc_price( var_price, quantity, dis_q, dis_p = 10, discount = true){
            let price = 0;
            quantity = quantity < 1 ? 1 : quantity;

            if( !dis_q || parseInt(quantity) < parseInt(dis_q) || !discount || parseInt(dis_q) === 0 ){

                price = parseFloat(var_price) * quantity;
            } else {
                // need to calculate discount from price without tax!
                const priceWithoutTax = (var_price / 1.21).toFixed(2);
                const discountPriceWithoutTax = (priceWithoutTax - priceWithoutTax * 10 / 100).toFixed(2);
                const discountPriceWithTax = (discountPriceWithoutTax * 1.21).toFixed(2);

                price = discountPriceWithTax * quantity;
            }

            return price.toFixed(2);
        }

        function calc_regular_price( var_price, quantity ){
            let price = 0;
            quantity = quantity < 1 ? 1 : quantity;
            price = var_price * quantity;

            return price.toFixed(2);
        }
    }

    quantityDiscountInit();

    $( document ).on('vet-filters-ajax-complete', function() {
        quantityDiscountInit();
    });
});